export class SendSuggestionInputDTO {
  recaptcha: string;
  email: string;
  fullName: string;
  subject: string;
  description: string;

  constructor() {
    this.recaptcha = "";
    this.email = "";
    this.fullName = "";
    this.subject = "";
    this.description = "";
  }
}
